import React, { useState } from 'react'

export const useKeyboardHook = () => {
  const [keyboardLayout, setKeyboardLayout] = useState({
    default: [
      'q w e r t y u i o p del',
      '{capslock} a s d f g h j k l',
      '&#946 z x c v b n m , .',
      '&#x222B space &#8730',
    ],
    shift: [
      'Q W E R T Y U I O P del',
      '{capslock} A S D F G H J K L',
      '&#946 Z X C V B N M , .',
      '&#x222B space &#8730',
    ],
    algebraicEquations: [
      'a1 a2 a3 a4 (□) a6 a7 % a8 del',
      'sin cos tan ± + - × ÷ = a9',
      'a10 a11 π ≤ ≥ < > a12 | .',
      '&#x222B space abc',
    ],
    geometricEquations: [
      'α β γ δ ε ζ η η θ ι del',
      'κ λ μ ν ξ ο π ρ σ τ',
      'abc υ φ χ ψ ω I V X C',
      'D space M',
    ],
    integrationEquations: [
      'I1 I2 I20 I27 | INULL1 del',
      'INULL2',
      'INULL2',
      'abc space &#8730',
    ],
  })
  const [keyboardDisplay, setDisplay] = useState({
    '{bksp}': 'backspace',
    '{capslock}': '⇪',
  })

  return [keyboardLayout, setKeyboardLayout, keyboardDisplay]
}

export const useNumericKeyboardHook = () => {
  const [numericLayout, setNumericLayout] = useState({
    default: [
      '1 2 3 {arrowup}',
      '4 5 6 {arrowdown}',
      '7 8 9 {arrowright}',
      '0 . {arrowleft}',
    ],
    shift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}'],
  })

  return [numericLayout, setNumericLayout]
}

export const useSymbolicKeyboardHook = () => {
  const [symbolLayout, setSymbolLayout] = useState({
    default: ['÷ s1 s2 s3 s4', 'x < > (□) s6', '- ≤ ≥ &#8730 %', '+ = ± π s5'],
    shift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}'],
  })

  return [symbolLayout, setSymbolLayout]
}
